<template lang="html">

  <section class="banner-contacto column-between" :inHome="inHome">


    <div class="container intro -xs column-between">

      <div class="left column-center">
        <h2 class="title -xs">{{$t('banner_contacto.titulo')}}</h2>
        <p>{{$t('banner_contacto.cuerpo')}}</p>
      </div>

      <div class="right" @click="toggleFormulario" :hide="show" v-if="show == false">
        <a class="btn"><span>{{$t('banner_contacto.boton')}}</span></a>
      </div>
    </div>

    <div class="formulario container" :show="show">

      <formulario></formulario>
      <div class="right mt-60" @click="toggleFormulario" :hide="show" v-if="show">
        <a class="btn"><span>{{$t('banners_experiencia.ruta_cervantina.cerrar')}}</span></a>

      </div>
    </div>

  </section>

</template>

<script lang="js">

  import { mapActions } from 'vuex';
  import rrss from '@/components/parts/rrss'
  import formulario from '@/components/view-parts/contacto/formulario'


  export default {
    name: 'banner-contacto',
    data() {
      return {
        show: false
      }
    },
    methods: {
      ...mapActions(['changeGhostMenu']),
      toggleFormulario: function () {
        this.show = !this.show;
      },
    },
    watch: {
      'show' : function(){
        $('html, body').animate({
          scrollTop: '10000'
        }, 2000);
      }
    },
    components: {
      'rrss': rrss,
      'formulario': formulario
    },
    computed: {
      inHome: function () {
        return (this.$route.name == "home");
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

  .banner-contacto {
    padding: 50px 0;
    background: $mud-brown;
    color: $white;
    /* height: 100vh; */
    width: 100%;
    /* position: absolute;
    left: 0;
    bottom: calc(-100vh + 295px); */
    z-index: 25;
    transition-duration: 1s;
    will-change: transform;
    justify-content: space-between;
    -webkit-justify-content: space-between;
  }

  /* .banner-contacto[show=true]{
    transform: translateY(calc(-100vh + 295px));
    justify-content: center;
    -webkit-justify-content: center;
  } */

  .banner-contacto .intro {
    margin-bottom: 50px;
    transition: 1s;
    /*background: red;*/
    height: 140px;
  }

  .banner-contacto .left {
    margin-bottom: 20px;
  }

  .banner-contacto .left .title {
    text-align: center;
  }

  .banner-contacto .intro .right {
    transition: 1s;
  }

  .banner-contacto[show=true] .intro .right {
    opacity: 1;
    pointer-events: none;
  }

  .banner-contacto[show=true] .intro {
    /*transform: translateY(90px);*/
    margin-bottom: 0;
  }

  .formulario {
    display: none;
    max-width: 1200px;
  }

  .formulario[show="true"] {
    display: block;
  }

  .bottom .title {
    width: auto;
    margin-bottom: 0;
  }


  .cerrar {
    position: absolute;
    right: 50px;
    top: 30px;
    font-size: 40px;
    color: white;
    opacity: 0;
    transform: translateY(40px);
    transition: 1s;
  }

  [show=true] .cerrar {
    opacity: 1;
    transform: translateY(0);
  }

  .mt-60 {
    margin-top: 60px;
  }

  @media screen and (max-width: 900px) {

    .banner-contacto[show=true][inHome=true] {
      padding-top: 80px;
    }

    .banner-contacto .intro {
      height: auto;
    }

    p {
      text-align: center;
    }
  }

  @media screen and (max-width: 830px) {
    .banner-contacto {
      position: relative;
      bottom: auto;
      left: auto;
      height: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/banner-contacto.vue